<template>
  <div
    class="z-10 playerBorder bg-contain bg-no-repeat w-[300px] xl:w-[430px] max-h-[115px] fixed bottom-8 left-1/2 transform -translate-x-1/2 xl:pt-[8px] pl-[8px] xl:pl-[9px]">
    <div
      class="playerBackground w-[282px] xl:w-[410px] h-[58px] xl:h-[90px] flex flex-row bg-contain bg-no-repeat mt-[1.15rem] pl-0 xl:pl-2 pt-3 xl:pt-4 relative">
      <div class="bg-center h-16 -ml-1 xl:ml-0 -mt-[37px] xl:-mt-[22px] w-[65px] [image-rendering:pixelated]"
           :style="{backgroundImage: `url('${avatarUrl(store.radio.name, { action: 'std,crr=', img_format: '', dance: '', effect: '', frame_num: 30 })}')`}"></div>
      <span class="font-poppins font-semibold text-xs xl:text-base w-[65px] xl:w-[110px] truncate">
        {{ store.radio.name }}
      </span>
      <button
        @click="store.storePlay(!store.radio.playing)"
        class="absolute -top-[10px] xl:-top-[19px] left-[142px] xl:left-[204px] playerCircle bg-contain bg-no-repeat w-[60px] xl:w-[95px] h-[60px] xl:h-[95px]">
        <i v-show="store.radio.playing" class="fa-solid fa-pause text-2xl"></i>
        <i v-show="!store.radio.playing" class="fa-solid fa-play text-2xl"></i>
      </button>
      <button class="absolute right-3.5 xl:right-7 xl:top-4 flex flex-row gap-2 items-center"
              @click="store.modRd = !store.modRd">
        <img :src="headphonesAzulIcon" alt="ouvintes" />
        <span class="font-bold text-xs xl:text-base">{{ store.radio.ouvintes }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { avatarUrl } from '@/services/api.js'
import { useStore } from '@/stores/index.js'
import headphonesAzulIcon from '@/assets/headphonesAzul.svg'

const store = useStore()
</script>

<style scoped>
.playerBorder {
  background-image: url("@/assets/player/border.svg");
}

.playerBackground {
  background-image: url("@/assets/player/background.svg");
}

.playerCircle {
  background-image: url("@/assets/player/circle.svg");
}
</style>
